export default __webpack_public_path__ + "b8db0d9595b02ad9d78fe3ecf31f62b5.png";